
import {Err} from "./err.js"

export class CryptionErr extends Err {}

